import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from '@studio/legacy-components';
import { OpenInBuilderManager } from 'next/components/OpenInBuilder';
import { create } from 'next/entities/pins';
import { openExperience } from 'next/lib/builder';
import { selectDefaultTheme, Shape as ThemeShape } from 'next/entities/themes';

import CreatePinModal from './CreatePinModal';

const STATES = {
  IDLE: 'IDLE',
  CREATE: 'CREATE',
  IN_FLIGHT: 'IN_FLIGHT',
  OPEN_IN_BUILDER: 'OPEN_IN_BUILDER',
  ERROR: 'ERROR',
};

export const CreatePinManager = ({ defaultTheme, onCreate }) => {
  const [experience, setExperience] = useState();
  const [state, setState] = useState(STATES.IDLE);

  const handleOpen = () => void setState(STATES.CREATE);

  const handleClose = () => void setState(STATES.IDLE);

  const handleSubmit = async values => {
    try {
      setState(STATES.IN_FLIGHT);

      const pinExperience = await onCreate({
        name: values.name,
        previewUrl: values.previewUrl,
        theme: values.theme,
        tagIds: values.tagIds,
        template: 'persistent',
      });

      setExperience(pinExperience);
      setState(STATES.OPEN_IN_BUILDER);
    } catch {
      setState(STATES.ERROR);
    }
  };

  const handleNavigate = () =>
    openExperience({ experience: experience.id, url: experience.previewUrl });

  return (
    <>
      <CreatePinModal
        visible={[STATES.CREATE, STATES.IN_FLIGHT, STATES.ERROR].includes(
          state
        )}
        disabled={state === STATES.IN_FLIGHT}
        hasError={state === STATES.ERROR}
        onSubmit={handleSubmit}
        onClose={handleClose}
        defaultTheme={defaultTheme}
      />
      <OpenInBuilderManager
        type="pins"
        visible={state === STATES.OPEN_IN_BUILDER}
        onClose={handleClose}
        onNavigate={handleNavigate}
      />
      <Button onClick={handleOpen}>Create a Pin</Button>
    </>
  );
};

CreatePinManager.propTypes = {
  defaultTheme: ThemeShape,
  onCreate: PropTypes.func,
};

const mapStateToProps = state => ({
  defaultTheme: selectDefaultTheme(state),
});

const mapDispatchToProps = {
  onCreate: values => create(values),
};

export default connect(mapStateToProps, mapDispatchToProps)(CreatePinManager);
